import { IonButton, IonCol, IonContent, IonPage } from '@ionic/react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Slide from './Slide';
import { useStores } from 'models';
import Trans from 'util/Trans';
import { useHistory } from 'react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const OnBoarding = () => {
  const { appData } = useStores();
  const history = useHistory();
  const { t } = useTranslation();

  const slideConfigs = useMemo(
    () => ({
      slide2: {
        title: <Trans i18nKey="ONBOARDING_HEADER">Onboarding Header</Trans>,
        description: (
          <Trans i18nKey="ONBOARDING_DESCRIPTION">Onboarding Description</Trans>
        ),
        imageUrl: 'assets/images/slide_header_2.png',
      },
    }),
    [t]
  );

  const dismissOnboarding = () => {
    appData.completeOnboarding();
    history.replace('/profile');
  };
  return (
    <IonPage>
      <IonContent forceOverscroll={false} id="loginScreen" fullscreen>
        <Swiper
          modules={[Pagination]}
          initialSlide={0}
          style={{
            height: '100%',
            color: 'black',
            backgroundColor: 'white',
          }}
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <Slide
              key={2}
              imageUrl={slideConfigs.slide2.imageUrl}
              title={slideConfigs.slide2.title}
              description={slideConfigs.slide2.description}
              buttons={
                <IonCol>
                  <IonButton
                    expand="block"
                    color="secondary"
                    href={'https://spinnax.com/en/manual-freak'}
                  >
                    <Trans i18nKey="GOTO_INSTRUCTIONS">Zur Anleitung</Trans>
                  </IonButton>
                  <div style={{ height: '24px' }} />
                  <IonButton
                    expand="block"
                    color="primary"
                    onClick={dismissOnboarding}
                  >
                    <Trans i18nKey="PROCEED_TO_APP">Weiter zur App</Trans>
                  </IonButton>
                </IonCol>
              }
            />
          </SwiperSlide>
        </Swiper>
      </IonContent>
    </IonPage>
  );
};

export default OnBoarding;
